module.exports = "/_next/static/files/043c2bcfa48fb3e97442013e1e767a42.png";